import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function RecordedPreview({ blob, video, onCancel }: { blob: Blob; video: boolean; onCancel: () => void }) {
  const { t } = useTranslation('chatView');
  const [url, setUrl] = useState('');
  useEffect(() => {
    const source = URL.createObjectURL(blob);
    setUrl(source);
    return () => URL.revokeObjectURL(source);
  }, [blob]);
  return <div className="recording-bar">
    <button type="button" className="editing-cancel" aria-label={t('recording.cancel')} onClick={onCancel}>✕</button>
    {url && (video ? <video src={url} controls playsInline style={{ maxHeight: 180, maxWidth: '70%' }} /> : <audio src={url} controls />)}
  </div>;
}
